<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <form class="form-group flex column filter-form" [formGroup]="form">
    <!-- date -->
    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.Time" | translate }}</mat-label>
      <div class="dropdown-field">
        <app-date-range
        formControlName="dateRange"
        [showCustomDateOption]="true"
      ></app-date-range>
      </div>
    </div>

    <!-- CreatedBy -->
    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.CreatedBy" | translate }}</mat-label>
      <div class="dropdown-field">
        <app-lazy-dropdown
        formControlName="creatorId"
        [multiple]="true"
        [lookup]="creators"
      ></app-lazy-dropdown>
      </div>
    </div>

    <!-- status -->
    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.Status" | translate }}</mat-label>
      <div class="dropdown-field">
        <app-lazy-dropdown
        formControlName="status"
        [lookup]="InvoiceStatusOptions"
      ></app-lazy-dropdown>
      </div>
    </div>
  </form>
</app-state-section>
